var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-container"},[_c('b-spinner',{attrs:{"small":""}}),_c('span',{staticClass:"spinner-text"},[_vm._v("Thinking...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }